<template>
  <transition>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-title-box">
            <div class="page-title-right float-left">
              <ol class="breadcrumb m-0"> 
                <li class="breadcrumb-item active">Dental Services</li>
                <li class="breadcrumb-item"><a href="javascript:void(0);">Service Configurations</a></li>
              </ol>
            </div>
          </div>
        </div>
      </div> 

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">

              <!-- Service Selector -->
              <div class="form-group col-md-4 mb-3">
                <label>Select Service</label>
                <select class="form-control" v-model="selectedService" @change="loadConfigurations">
                  <option value="">-- Select Service --</option>
                  <option v-for="s in services" :key="s.id" :value="s.id">{{ s.name }}</option>
                </select>
              </div>

              <!-- Configuration List -->
              <div v-if="configurations.length">
                <div v-for="(config, cindex) in configurations" :key="config.id" class="mt-4 border p-3 rounded">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h4 class="mb-0">Day {{ config.day_number }}</h4>
                    <div class="actions">
                      <button type="button" class="btn btn-sm btn-warning me-2" @click="editConfig(config)"><i class="fas fa-edit"></i></button>
                      <button type="button" class="btn btn-sm btn-danger" @click="deleteConfig(config)" v-if="cindex == (configurations.length - 1)"><i class="fas fa-trash"></i></button>
                    </div>
                  </div>
                  <table class="table table-bordered">
                    <thead>
                      <tr><th>Item</th><th style="text-align: right;">Qty</th><th style="text-align: right;">Rate</th><th style="text-align: right;">Total</th></tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in config.config_items" :key="item.id">
                        <td>{{ item.product?.product_name }}</td>
                        <td style="text-align: right;">{{ item.qty }}</td>
                        <td style="text-align: right;">{{ item.rate }}</td>
                        <td style="text-align: right;">{{ item.total }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colspan="3" style="text-align: right;">Total Cost:</th>
                        <th style="text-align: right; color: red;">{{ config.total_costs }}</th>
                      </tr>
                    </tfoot>
                  </table>
                  <p><strong>Notes:</strong> {{ config.notes }}</p>
                </div>
              </div>

              <!-- Loading Indicator -->
              <div class="tab-pane show active" v-if="loading">
                  <div class="row"> 
                      <div class="col-md-5">  
                      </div>
                      <div class=" col-md-2"> 
                          <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                      </div>
                      <div class="col-md-5">  
                      </div>
                  </div>
              </div>

              <!-- Add New Day -->
              <div class="mt-4">
                <button class="btn btn-primary" @click="addNewDay">+ Add New Day Configuration</button>
              </div>

              <!-- Add Modal -->
              <Modal @close="showModal = false" :modalActive="showModal">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <button @click="showModal = false" type="button" class="btn btn-danger"><i class="fa fa-times"></i></button>
                        <h5 style="text-align: right;">Configuration Setup</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                          <div class="form-group col-md-4 mb-3">
                            <label>Day Number</label>
                            <input type="number" v-model="newDay.day_number" class="form-control">
                          </div>
                          <div class="form-group col-md-8 mb-3">
                            <label for="notes">Notes</label>
                            <input type="text" v-model="newDay.notes" class="form-control">
                          </div>
                        </div>

                        <table class="table table-sm mt-3">
                          <thead>
                            <tr><th width="30%">Product</th><th>Qty</th><th>Rate</th><th>Total</th><th></th></tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, i) in newDay.items" :key="i">
                              <td>
                                <select v-model="item.product_id" class="form-control" @change="updateRate(i)">
                                  <option value="">-- Select Product --</option>
                                  <option v-for="p in products" :value="p.product_id">{{ p.products.product_name }}</option>
                                </select>
                              </td>
                              <td><input type="number" v-model="item.qty" min="1" class="form-control" @input="updateRate(i)"></td>
                              <td><input type="number" v-model="item.rate" class="form-control" readonly></td>
                              <td><input type="number" v-model="item.total" class="form-control" readonly></td>
                              <td><button class="btn btn-danger btn-sm" @click="removeItem(i)">X</button></td>
                            </tr>
                          </tbody>
                        </table>

                        <div style="text-align: right; color: red;">
                          <strong>Total Cost: {{ newDay.items.reduce((sum, item) => sum + (item.qty * item.rate), 0).toFixed(6) }}</strong>
                        </div>

                        <button class="btn btn-success btn-sm mt-2" @click="addItem">+ Add Item</button>
                    </div>
                    <div class="modal-footer">\
                      <button class="btn btn-secondary" @click="showModal = false">Cancel</button>
                      <button class="btn btn-primary" @click="saveConfiguration">Save</button>
                    </div>
                </div>
              </Modal>
          

              <!-- Loading -->
              <!-- <div v-if="loading" class="text-center mt-4">
                <img src="../../../assets/image/loading.gif" width="100" />
              </div> -->

            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import Modal from "./../../helper/Modal";

export default {
  name: 'service_configuration',
  components: { Modal },
  data() {
    return {
      loading: false,
      services: [],
      selectedService: '',
      configurations: [],
      products: [],
      showModal: false,
      editMode: false,
      newDay: {
        id: null,
        day_number: null,
        notes: '',
        items: []
      },
    };
  },
  created() {
    this.fetchServices();
    this.fetchProducts();
  },
  methods: {
    fetchServices() {
      axios.get(this.apiUrl + '/hm/dental_services/list', this.headerjson)
        .then(res => this.services = res.data.data);
    },
    fetchProducts() {
      axios.get(this.apiUrl + '/hm/service_stock_details/list', this.headerjson)
        .then(res => this.products = res.data.data);
    },
    loadConfigurations() {
      if (!this.selectedService) return;
      this.loading = true;
      axios.get(`${this.apiUrl}/hm/dental_service_configurations/${this.selectedService}`, this.headerjson)
        .then(res => this.configurations = res.data)
        .finally(() => this.loading = false);
    },
    addNewDay() {
      if (!this.selectedService) {
        this.$toast.warning("Please select a service first.");
        return;
      }
      this.newDay = { id: null, day_number: this.configurations.length + 1, notes: '', items: [] };
      this.showModal = true;
    },
    addItem() {
      this.newDay.items.push({ product_id: '', qty: 1, rate: 0, total: 0 });
    },
    removeItem(i) {
      this.newDay.items.splice(i, 1);
    },
    updateRate(i) {
      const product = this.products.find(p => p.product_id === this.newDay.items[i].product_id);
      if (product) {
        this.newDay.items[i].rate = product.per_service_cost || 0;
        this.newDay.items[i].total = this.newDay.items[i].qty * this.newDay.items[i].rate;
      }
    },


    editConfig(config) {
      this.newDay = {
        id: config.id,
        day_number: config.day_number,
        notes: config.notes,
        items: config.config_items.map(item => ({
          product_id: item.product_id,
          qty: item.qty,
          rate: item.rate,
          total: item.qty * item.rate
        }))
      };
      this.showModal = true;
      this.editMode = true;
    },

    async saveConfiguration() {
      if (!this.selectedService) {
        this.$toast.warning('Please select a service first.');
        return;
      }

      if (!this.newDay.day_number) {
        this.$toast.warning('Please provide a day number.');
        return;
      }

      if (!this.newDay.items || !this.newDay.items.length) {
        this.$toast.warning('Please add at least one item.');
        return;
      }

      // Normalize items and compute totals
      const itemsPayload = this.newDay.items.map(it => {
        const qty = Number(it.qty) || 0;
        const rate = Number(it.rate) || 0;
        return {
          product_id: it.product_id,
          qty,
          rate,
          total: +(qty * rate).toFixed(6)
        };
      });

      const payload = {
        service_id: this.selectedService,
        day_number: Number(this.newDay.day_number),
        notes: this.newDay.notes || '',
        items: itemsPayload
      };

      this.loading = true;
      try {
        let res;
        if (this.editMode && this.newDay.id) {
          res = await axios.put(`${this.apiUrl}/hm/dental_service_configurations/${this.newDay.id}`, payload, this.headerjson);
          this.$toast.success(res?.data?.message || 'Configuration updated.');
          this.editMode = false;
        } else {
          res = await axios.post(`${this.apiUrl}/hm/dental_service_configurations`, payload, this.headerjson);
          this.$toast.success(res?.data?.message || 'Configuration saved.');
        }

        this.showModal = false;
        this.loadConfigurations();

        // reset newDay
        this.newDay = { id: null, day_number: null, notes: '', items: [] };
      } catch (err) {
        console.error(err);
        const msg = err?.response?.data?.message || (this.editMode ? 'Failed to update configuration' : 'Failed to save configuration');
        this.$toast.error(msg);
      } finally {
        this.loading = false;
      }
    },

    async deleteConfig(config) {
      // confirmation using SweetAlert style like your example
      this.$swal({
        title: 'Are you sure?',
        text: "You want delete this item!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          axios.delete(`${this.apiUrl}/hm/dental_service_configurations/${config.id}`, this.headerjson)
          .then(res => {
            if (res.status === 200) {
              this.loadConfigurations();
              this.$toast.success(res.data.message || 'Configuration deleted.');
            } else {
              this.$toast.error(res.data.message || 'Failed to delete configuration.');
            }
          })
          .catch(err => {
            this.$toast.error(err?.response?.data?.message || 'Failed to delete configuration.');
          })
          .finally(() => {
            this.loading = false;
          });
        } else {
          // cancelled by user
        }
      });
    }


  }
};
</script>
